import { useEffect, useState } from "react";
import { api } from "./api";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const imgUrl = (url) => (url?.startsWith("/api/") ? `${BASE}${url}` : url);

export function useSite(kind) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = async () => {
    const { data } = await api.get(`/site/${kind}`);
    setItems(data);
    setLoading(false);
  };
  useEffect(() => { reload().catch(() => { setLoading(false); }); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [kind]);
  return { items, loading, reload };
}

export function useSettings() {
  const [settings, setSettings] = useState(null);
  const reload = async () => {
    const { data } = await api.get("/site-settings");
    setSettings(data);
  };
  useEffect(() => { reload().catch(() => {}); }, []);
  return { settings, reload };
}
